import useTheme from '@rover/kibble/themes/useTheme';
import Marker from '@rover/react-lib/src/components/GeoMap/Marker/Marker';
import { useSearchUIContext } from '@rover/shared/js/providers/SearchUIContextProvider';

export type MapResult = {
  latitude: string;
  longitude: string;
  title: string;
  rank?: number | null;
};

type Props = MapResult & {
  onClick: () => void;
  index: number;
  showRank: boolean;
};

const ResultMarker = ({
  index,
  latitude,
  longitude,
  rank,
  onClick,
  title,
  showRank,
}: Props): JSX.Element => {
  const { colors, background } = useTheme();
  const { hoveredResultIndex, setHoveredResultIndex } = useSearchUIContext();
  const isHovered = hoveredResultIndex === index;
  const position = {
    lat: parseFloat(latitude),
    lng: parseFloat(longitude),
  };

  return (
    <Marker
      title={title}
      position={position}
      color={
        isHovered ? colors.interactive_link.primary_base : colors.interactive_text.primary_base
      }
      onClick={onClick}
      zIndex={isHovered ? 21 : index}
      onMouseEnter={() => {
        setHoveredResultIndex(index);
      }}
      onMouseLeave={() => {
        setHoveredResultIndex(null);
      }}
      content={showRank ? `${rank}` : undefined}
      borderColor={showRank ? undefined : background.primary}
      scale={isHovered ? 1.2 : 1}
    />
  );
};

export default ResultMarker;
